import { Incentive } from "../../models/Incentive";

export interface IPerception {
  name: string;
  description: string;
  amount: number;
  frequency: number;
  startDate: string;
  endDate: string;
  applicationDate: string;
  status: string;
}

export const PerceptionInitial: IPerception = {
  name: "",
  description: "",
  amount: 0,
  frequency: -99,
  startDate: "",
  endDate: "",
  applicationDate: "",
  status: 'activo',
};

export const PerceptionFilled = (values: Incentive): IPerception => {
  return {
    name: values.name,
    description: values.description,
    amount: Number(values.amount),
    frequency:
      FrequencyList.find((item) => item.name === values.frequency)?.id || -99,
    startDate: values.startDate,
    endDate: values.endDate,
    status: values.status,
    applicationDate: values.applicationDate
  };
};

export enum Frequency {
  quincenal = "quincenal",
  mensual = "mensual",
  semanal = "semanal",
  unico = "único",
  diario = "diario",
  anual = "anual",
}

export const FrequencyList = [
  { id: 1, name: "quincenal" },
  { id: 2, name: "mensual" },
  { id: 3, name: "semanal" },
  { id: 4, name: "único" },
  { id: 5, name: "diario" },
  { id: 6, name: "anual" },
];
